import {
  CSLBContractorSnapshotFragment,
  EntityVersionFragment,
  FieldFragment,
  FieldGroupFragment,
  FieldType,
  FieldValueDetailedFragment,
  FileFragment,
  ForeignValue,
  State,
  UserDataFragment,
} from '../../types/graphql'
import { RecordAutocompleteFieldValues } from '../components/form/shared/RecordAutocompleteCell/RecordAutocomplete'

export interface FieldDisplayInput {
  type: FieldType
  codeBookItemIds?: number[] | null
  contact?: {
    id?: number
    firstName?: string | null
    lastName?: string | null
    middleName?: string | null
    email?: string | null
    companyName?: string | null
    phoneNumber?: string | null
    faxNumber?: string | null
    title?: string | null
    addressLine1?: string | null
    addressLine2?: string | null
    city?: string | null
    state?: State | null
    zip?: string | null
  } | null
  checked?: boolean | null
  date?: string | null
  num?: number | null
  str?: string | null
  strs?: (string | null)[] | null
  cslbContractorSnapshot?: CSLBContractorSnapshotFragment | null
  record?: RecordAutocompleteFieldValues['selectedOption'] | null
  inspectionResult?: {
    id: number
    isPassing: boolean
    name: string
  } | null
  file?: FileFragment | null
  files?: (FileFragment | null)[] | null
  violationTypes?: {
    id?: number
    name?: string
  }[]
  recordCollections?:
    | ({
        id?: number
        name?: string | null
      } | null)[]
    | null
  foreignValue?: ForeignValue | null
  userHasAccessToForeignValue?: boolean | null
  entityVersions?: EntityVersionFragment[] | null
  childFieldGroups?: FieldGroupFragment[] | null
  childFieldGroupTemplateId?: number | null
  users?: UserDataFragment[] | null
}

export const getFieldDisplayInputFromFieldFragment = (
  field: FieldFragment | FieldValueDetailedFragment
): FieldDisplayInput => {
  return {
    ...field,
    codeBookItemIds: field.codeBookItems?.map((cbi) => cbi.id),
    childFieldGroupTemplateId: field.childFieldGroupTemplate?.id,
    ...('childFieldGroups' in field && {
      childFieldGroups: field.childFieldGroups,
    }),
  }
}
